import { render, staticRenderFns } from "./list_happiness_tips_categories_page.vue?vue&type=template&id=1cec1891&scoped=true"
import script from "./list_happiness_tips_categories_page.vue?vue&type=script&lang=js"
export * from "./list_happiness_tips_categories_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec1891",
  null
  
)

export default component.exports